<template>
    <div class="sg-custom-toggle sg-checkmark" :class="{ 'sg-disabled': disabled }">
        <label :for="`vrm-toggle-radio-${_uid}`">
            <input
                :id="`vrm-toggle-radio-${_uid}`"
                v-model="state"
                type="radio"
                :value="value"
                :disabled="disabled"
            />
            <div class="sg-alternative-display">
                <div class="sg-vrm-icon_054_check-16px" />
            </div>
            <div class="sg-caption-container">
                <div class="sg-caption">
                    <slot />
                </div>
            </div>
        </label>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Component, Prop } from 'vue-property-decorator';
import ToggleMixin from '@/vue/components/shared/toggles/ToggleMixin';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component({ inheritAttrs: false })
@AngularDirective('vrm-toggle-radio')
export default class VrmToggleRadio extends ToggleMixin {
    // For some reason v-model does not use the currect binding for :value when using v-bind=$attrs
    // So this prop allows us to correclty bind it
    @Prop()
    value;
}
</script>
